<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="item.redirect==='underfined'||index==levelList.length-1" class="no-redirect">
          {{ item.meta.title }}
        </span>
        <a class="redirect" v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {

  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },

  created() {
    this.getBreadcrumb()
  },

  methods: {
    getBreadcrumb() {
      /* 仅显示路线元标题 */
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">
.app-breadcrumb {
  height: 44px;
  line-height: 44px;
  margin-left: 20px!important;
  margin-left: $fs-mini;
  display: inline-block;
  font-size: $fs-small-l;
  .el-breadcrumb-item,
  .el-breadcrumb__inner,
  .no-redirect,
  .redirect
   {
    display: inline-block;
    height: 44px;
    line-height: 44px;
  }
  .no-redirect {
    cursor: text;
    font-weight: 700;
    color: $color-BlackGrey;
  }
  .redirect {
    font-weight: 400;
    color: $color-LightGrey;
  }
}
</style>